<template><UserAgreementEditorBase agreement-type="MOU File" /></template>
<script>
import UserAgreementEditorBase from '@/views/user/UserAgreementEditorBase'
export default { name: 'UserMOUAgreement', components: { UserAgreementEditorBase } }
</script>
